<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="LIMITACIONES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <b-row class="mb-5 flex-column">
            <p class="configurator-label mb-0">
              <font-awesome-icon :icon="['far', 'sticky-note']" size="sm" class="text-muted" fixed-width />
              Coloque detalles importantes
            </p>
            <p class="text-muted " style="font-size: 17px;">
              Use el espacio a continuación para notas varias o información específica del trabajo que no se incluya en otro lugar
            </p>
            <div>
              <b-textarea
                v-model="form.limitation_notes"
                rows="14"
                trim
                size="lg"
                style="outline: 1px solid black; outline-offset: 5px; background-color: #fffedf; border: 0px;"
              />
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ConfiguratorStepTitle from '../ConfiguratorStepTitle'

export default {
  name: 'Limitations',
  components: { ConfiguratorStepTitle },
  props: {
    updateConfigurable: Function
  },
  computed: {
    ...mapState({ anden: state => state.configurator.configurable }),
    ...mapGetters(['configuratorStepNumber'])
  },
  data () {
    return {
      form: {
        limitation_notes: ''
      }
    }
  },
  mounted () {
    if (this.anden) {
      this.form.limitation_notes = this.anden.limitation_notes
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.anden[key])
    }
  }
}
</script>
